import * as React from "react";
import { NumericInput } from "../../externals";
export class StartsAtSelector extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { id: "startsAtOpt", className: "tab-option-inline", style: { paddingTop: "8px" } },
            React.createElement("label", { className: "option-item" }, "Starts at: "),
            React.createElement(NumericInput, { allowNumericCharactersOnly: true, max: 23, min: 0, placeholder: "hours", className: "option-item", onValueChange: (value) => {
                    this.props.startsAtChange([
                        value.toString(),
                        this.props.startsAt[1],
                    ]);
                }, value: this.props.startsAt[0] }),
            React.createElement(NumericInput, { allowNumericCharactersOnly: true, max: 59, min: 0, placeholder: "minutes", onValueChange: (value) => {
                    this.props.startsAtChange([
                        this.props.startsAt[0],
                        value.toString(),
                    ]);
                }, value: this.props.startsAt[1] })));
    }
}
//# sourceMappingURL=StartsAtSelector.js.map